import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import moment from 'moment';
import { isMobile } from "../../utils";
import DateRangePicker from 'react-bootstrap-daterangepicker/lib/index.js';
import { datepickerLocale } from "../../lang";

// svgs
import caretDropSVG from '../inlineSVGs/caretDropSVG';
import caretDropFullSVG from '../inlineSVGs/caretDropFullSVG';

// style
import 'react-bootstrap-daterangepicker/css/daterangepicker.css';
import './Datepicker.css';

class Datepicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ranges: {
                'היום': [moment().startOf('day'), moment().endOf('day')],
                'מחר': [moment().add(1, 'days').startOf('day'), moment().add(1, 'days').endOf('day')],
                // 'This Week': [moment().startOf('day'), moment().endOf('week')],
                '7 ימים קרובים': [moment().startOf('day'), moment().add(+7, 'days')],
                // 'This Month': [moment().startOf('day'), moment().endOf('day')]
                '30 ימים קרובים': [moment().startOf('day'), moment().add(+30, 'days')]
            },
            startDate: moment(),
            endDate: moment(),
            // chosenLabel: this.props.datatypes && this.props.datatypes.defaults.chosenLabel
        };
    }

    componentDidMount() {
        let ranges = {...this.state.ranges};
        let chosenLabel = this.props.datatypes.defaults.chosenLabel;

        // nasty hack...
        if (chosenLabel === 'Next 30 Days') chosenLabel = '30 ימים קרובים'
        this.setState({
            chosenLabel: chosenLabel,
            startDate: ranges[chosenLabel][0],
            endDate: ranges[chosenLabel][1]
        });

        this.props.onDatesChange(ranges[chosenLabel][0], ranges[chosenLabel][1], chosenLabel);
    }

    handleEvent(event, picker) {
        if (!this.state) return;
        // In case the user clicked APPLY we want to set the new date range and update the filters + pins
        if (event.type === 'apply') {
            this.setState({
                startDate: picker.startDate,
                endDate: picker.endDate,
                chosenLabel: picker.chosenLabel
            });

            this.props.onDatesChange(picker.startDate, picker.endDate, picker.chosenLabel);
        }
    }

    render() {
        let label;
        if (this.state.chosenLabel === 'Custom Range') {
            let start = this.state.startDate.format('DD MMM');
            let end = this.state.endDate.format('DD MMM');
            label = start + ' - ' + end;

            if (start === end) {
                label = start;
            }

        } else {
            label = this.state.chosenLabel;
        }

        if (!this.props) return null;

        return (
                <DateRangePicker
                    opens="left"
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    ranges={this.state.ranges}
                    minDate={moment().startOf('day')}
                    onEvent={(event, picker) => this.handleEvent(event, picker)}
                    onShow={() => console.log('showing calendar')}
                    onHide={() => console.log('hiding calendar')}
                    locale={datepickerLocale}
                >
                    <button className={`selected-date-range-btn`} style={{width:'100%'}}>
                        <div className="pull-left"><BS.Glyphicon glyph="calendar" /></div>
                        <div className="pull-right">
                            <span>
                                <label>{!isMobile() ? label : ''}</label>
                                {this.props.isCaret && window.innerWidth > 950 ? <SVGInline className="caret-icon" svg={caretDropSVG} component="i"/> : null}
                                {this.props.isCaretMobile ? <SVGInline className="caret-full-icon" svg={caretDropFullSVG} component="i"/> : null}
                                {isMobile() ? <label className="date-label-mobile">{label}</label> : ''}
                            </span>
                        </div>
                    </button>
                </DateRangePicker>
        );
    }
}

Datepicker.propTypes = {
    isCaret: PropTypes.bool,
    isCaretMobile: PropTypes.bool,
    onDatesChange: PropTypes.func,
    datatypes: PropTypes.object,
    isSignupModalOpen: PropTypes.bool
};

export default Datepicker;



// WEBPACK FOOTER //
// ./src/Components/Main/Datepicker.js